// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WarningOutlinedSvg from "@ant-design/icons-svg/es/asn/WarningOutlined";
import AntdIcon from '../components/AntdIcon';

var WarningOutlined = function WarningOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WarningOutlinedSvg
  }));
};

WarningOutlined.displayName = 'WarningOutlined';
export default React.forwardRef(WarningOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/WarningOutlined.js
// module id = 2047
// module chunks = 0